import { AuthContextInterface, withAuthContext } from '@amzn/awscat-react-components';
import { ButtonDropdown, ButtonDropdownProps } from '@amzn/awsui-components-react';
import { isPartnerUserId } from '@amzn/caracal-infrastructure-common';
import { FunctionComponent, useEffect, useState } from 'react';

import { AppLabelsContextInterface, withAppLabelsContext } from '../../../common/AppLabelsContext';

type ResourceDropdownPros = AuthContextInterface & AppLabelsContextInterface & { isAuthenticated: boolean };

const ResourcesDropdown: FunctionComponent<ResourceDropdownPros> = ({ isAuthenticated, auth, appLabels }): JSX.Element | null => {
    const [isPartner, setIsPartner] = useState(false);

    useEffect(() => {
        try {
            setIsPartner(isPartnerUserId(auth?.getUserInfo()?.userId));
        } catch {
            // Auth may not be available yet
        }
    }, [auth]);

    if (!isAuthenticated || isPartner) return null;

    const dropdownItems: ButtonDropdownProps.ItemOrGroup[] = [
        {
            id: 'faq',
            text: appLabels.landing.moreResources.items[1].linkText,
            href: appLabels.landing.moreResources.items[1].linkLocation,
            external: true,
        },
    ];

    return (
        <ButtonDropdown expandToViewport variant='normal' items={dropdownItems}>
            {appLabels.header.resources.title}
        </ButtonDropdown>
    );
};

export default withAuthContext(withAppLabelsContext(ResourcesDropdown));
